import PropTypes from 'prop-types';
import { memo } from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const HtmlSanitizer = require('sanitize-text/sanitizers/HtmlSanitizer');

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'I18n... Remove this comment to see the full error message
import FormattedDuration from 'I18n/components/FormattedDuration';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Ticket from '../../models/Ticket';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TITLE_MAX_LENGTH = 30;
const BODY_MAX_LENGTH = 100;
function TicketItem(props) {
  function getChannelIcon() {
    const {
      ticket: {
        channel
      }
    } = props;
    if (channel === 'WEBTICKET') {
      return 'email';
    } else if (channel === 'CHAT') {
      return 'messages';
    } else if (channel === 'INBOUND_PHONE') {
      return 'calling';
    } else {
      return 'question';
    }
  }
  function prepareHtmlTitle() {
    const {
      title
    } = props.ticket;
    const ellipsis = title.length > TITLE_MAX_LENGTH ? '...' : '';
    return HtmlSanitizer.formatHtml(title.substr(0, TITLE_MAX_LENGTH).trim().concat(ellipsis));
  }
  function prepareHtmlBody() {
    const {
      body
    } = props.ticket;
    const ellipsis = body.length > BODY_MAX_LENGTH ? '...' : '';
    return HtmlSanitizer.formatHtml(body.substr(0, BODY_MAX_LENGTH).trim().concat(ellipsis));
  }
  function prepareTooltip() {
    const {
      ticket: {
        productArea,
        goal,
        roadblock,
        resolution
      }
    } = props;
    let tooltip = productArea;
    tooltip = goal ? `${tooltip}; ${goal}` : tooltip;
    tooltip = roadblock ? `${tooltip}; ${roadblock}` : tooltip;
    tooltip = resolution ? `${tooltip}; ${resolution}` : tooltip;
    return tooltip;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Small, {
      className: "m-bottom-1",
      use: "help",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-2",
        "data-test-id": "ticket-item-channel-icon",
        name: getChannelIcon()
      }), /*#__PURE__*/_jsx(UITooltip, {
        "data-test-id": "ticket-item-grr-tooltip",
        title: prepareTooltip(),
        children: /*#__PURE__*/_jsx("span", {
          children: props.ticket.productArea
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-1",
      children: /*#__PURE__*/_jsx(UILink, {
        "data-test-id": "ticket-item-link",
        external: true,
        onClick: () => Track.ticketOpened(),
        href: props.ticket.url,
        children: /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: prepareHtmlTitle()
          }
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-1",
      "data-test-id": "ticket-item-body",
      dangerouslySetInnerHTML: {
        __html: prepareHtmlBody()
      }
    }), /*#__PURE__*/_jsx(Small, {
      "data-test-id": "ticket-item-created-at-container",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        "data-test-id": "ticket-item-created-at",
        includeAffix: true,
        to: props.ticket.createdAt * 1000
      })
    })]
  });
}
TicketItem.propTypes = {
  ticket: PropTypes.instanceOf(Ticket).isRequired
};
export default /*#__PURE__*/memo(TicketItem);